import { render, staticRenderFns } from "./ImageAdmin.vue?vue&type=template&id=20f0b975&"
import script from "./ImageAdmin.vue?vue&type=script&lang=js&"
export * from "./ImageAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ImageAdmin.vue?vue&type=style&index=0&id=20f0b975&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports